import { useState } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import { Newsletter } from "../components/Newsletter";
import { useLanguage } from "../context/LanguageContext";
import { TranslatedText } from "../components/TranslatedText";

export const Contact = () => {
  const { language } = useLanguage();
  
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  };

  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState("send");
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(false);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("sending");
    setLoading(true);

    try {
      // Update the API endpoint to point to your Spring Boot backend
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDetails),
      });

      const result = await response.json();

      setFormDetails(formInitialDetails);
      setStatus({
        success: result.code === 200,
        message: result.message,
      });
    } catch (error) {
      console.error("Error submitting contact form:", error);
      setStatus({
        success: false,
        message: language === 'en' 
          ? "An error occurred. Please try again later." 
          : "发生错误。请稍后再试。",
      });
    } finally {
      setButtonText("send");
      setLoading(false);
    }
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validateForm = () => {
    return (
      formDetails.firstName.trim() !== "" &&
      formDetails.lastName.trim() !== "" &&
      validateEmail(formDetails.email) &&
      formDetails.message.trim() !== ""
    );
  };

  return (
    <section className="contact" id="contact">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={12} className="mb-4 mb-md-0">
            <Newsletter />
          </Col>
          <Col lg={6} md={12}>
            <h2><TranslatedText textKey="getInTouch" /></h2>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col sm={6} className="px-1">
                  <input
                    type="text"
                    value={formDetails.firstName}
                    placeholder={language === 'en' ? "First Name" : "名"}
                    onChange={(e) => onFormUpdate("firstName", e.target.value)}
                    required
                  />
                </Col>
                <Col sm={6} className="px-1">
                  <input
                    type="text"
                    value={formDetails.lastName}
                    placeholder={language === 'en' ? "Last Name" : "姓"}
                    onChange={(e) => onFormUpdate("lastName", e.target.value)}
                    required
                  />
                </Col>
                <Col sm={6} className="px-1">
                  <input
                    type="email"
                    value={formDetails.email}
                    placeholder={language === 'en' ? "Email Address" : "电子邮箱"}
                    onChange={(e) => onFormUpdate("email", e.target.value)}
                    required
                  />
                </Col>
                <Col sm={6} className="px-1">
                  <input
                    type="text"
                    value={formDetails.phone}
                    placeholder={language === 'en' ? "Phone No." : "电话号码"}
                    onChange={(e) => onFormUpdate("phone", e.target.value)}
                  />
                </Col>
                <Col>
                  <textarea
                    rows="6"
                    value={formDetails.message}
                    placeholder={language === 'en' ? "Message" : "留言"}
                    onChange={(e) => onFormUpdate("message", e.target.value)}
                    required
                  ></textarea>
                  <button type="submit" disabled={loading || !validateForm()}>
                    <span><TranslatedText textKey={buttonText} /></span>
                  </button>
                </Col>
                {status.message && (
                  <Col>
                    <Alert
                      variant={status.success ? "success" : "danger"}
                      className="mt-3"
                    >
                      {status.message}
                    </Alert>
                  </Col>
                )}
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};